module.exports = __webpack_public_path__ + "static/assets/105d2d98141c70da23386368cdd61446.svg";